var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"social-icon"},_vm._l((_vm.socialList),function(social,i){return _c('li',{key:i},[_c('a',{attrs:{"target":"_blank","href":social.url}},[_c('i',{staticClass:"fab",class:social.icon})])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }